<!--
 * @Author: zhaoliang
 * @Date: 2025-01-22 10:42:57
 * @LastEditTime: 2026-05-13 17:36:23
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/components/PDFViewer/index.vue
 *
-->
<template>
  <div>
    <canvas class="fs-mask" id="pdfCanvas" style="display: block"></canvas>
    <iframe id="pdfFrame" style="display: none"></iframe>
  </div>
</template>

<script>
  import { debounce } from 'lodash';

  export default {
    props: ['pdfUrl'],
    data() {
      return {
        pageNum: 1,
        pageCount: 0,
      };
    },
    created() {
      this.pdfDoc = null;
      this.currentRenderTask = null;
      this.resizeHandler = debounce(() => {
        this.renderPage(this.pageNum);
      }, 500);
    },
    mounted() {
      this.loadPDF();
      window.addEventListener('resize', this.resizeHandler);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
      this.destroyPDF();
    },
    methods: {
      async destroyPDF() {
        // 组件销毁前取消任务
        if (this.currentRenderTask) {
          this.currentRenderTask.cancel();
          this.currentRenderTask = null;
        }
        if (this.pdfDoc) {
          const destroyTask = this.pdfDoc.destroy();
          if (destroyTask && typeof destroyTask.then === 'function') {
            destroyTask.then(() => console.log('PDF document destroyed'));
          } else {
            console.log('PDF document destroyed (sync)');
          }
          this.pdfDoc = null;
        }
      },
      async loadPDF() {
        try {
          const blob = new Blob([this.pdfUrl], { type: 'application/pdf' });
          const arrayBuffer = await blob.arrayBuffer();
          const loadingTask = globalThis.pdfjsLib.getDocument({ data: arrayBuffer });
          this.pdfDoc = await loadingTask.promise;
          this.pageCount = this.pdfDoc.numPages;
          this.renderPage(this.pageNum);
        } catch (error) {
          console.error('Error loading PDF: ', error);
        }
      },
      async renderPage(num) {
        if (!this.pdfDoc) return;
        if (this.currentRenderTask) {
          this.currentRenderTask.cancel();
          this.currentRenderTask = null;
        }
        const page = await this.pdfDoc.getPage(num);
        const viewport = page.getViewport({ scale: 1 });
        const canvas = document.getElementById('pdfCanvas');
        const container = canvas.parentElement.parentElement;
        // 设置 canvas 的宽度与父 div 相同
        canvas.width = container.clientWidth;
        // 设置 canvas 的高度跟随宽度等比例缩放
        canvas.height = (viewport.height / viewport.width) * canvas.width;
        // 缩放 canvas 以适应父 div
        const scale = Math.min(canvas.width / viewport.width, canvas.height / viewport.height);
        const scaledViewport = page.getViewport({ scale });
        const context = canvas.getContext('2d');

        const renderContext = {
          canvasContext: context,
          viewport: scaledViewport,
        };
        this.currentRenderTask = page.render(renderContext);
        await this.currentRenderTask.promise.then(() => {
          console.log('Page rendered successfully');
          this.currentRenderTask = null;
        });
      },
      printPDF() {
        const blob = new Blob([this.pdfUrl], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const iframe = document.getElementById('pdfFrame');
        iframe.src = url;
        iframe.onload = function () {
          setTimeout(() => {
            iframe.contentWindow.print();
            URL.revokeObjectURL(url);
          }, 1000); // 延迟 1 秒确保 PDF 完全加载
        };
      },
    },
  };
</script>
